import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  LOCATIONS_INDEX_REQUESTED,
  LOCATIONS_INDEX_SUCCESS,
  LOCATIONS_INDEX_FAILURE,
  CORPORATE_LOCATION_CREATE_REQUESTED,
  CORPORATE_LOCATION_CREATE_SUCCESS,
  CORPORATE_LOCATION_CREATE_FAILURE,
  CORPORATE_LOCATION_UPDATE_REQUESTED,
  CORPORATE_LOCATION_UPDATE_SUCCESS,
  CORPORATE_LOCATION_UPDATE_FAILURE,
  CORPORATE_LOCATION_DELETE_REQUESTED,
  CORPORATE_LOCATION_DELETE_SUCCESS,
  CORPORATE_LOCATION_DELETE_FAILURE,
} from '../types';

export const locationsIndexRequested = () => {
  return {
    type: LOCATIONS_INDEX_REQUESTED
  }
};

export const locationsIndexSuccess = (locations) => {
  return {
    type: LOCATIONS_INDEX_SUCCESS,
    payload: locations
  }
};

export const locationsIndexFailure = () => {
  return {
    type: LOCATIONS_INDEX_FAILURE
  }
};

export const locationsCreateRequested = () => {
  return {
    type: CORPORATE_LOCATION_CREATE_REQUESTED
  }
};

export const locationsCreateSuccess = (location) => {
  return {
    type: CORPORATE_LOCATION_CREATE_SUCCESS,
    location: location
  }
};

export const locationsCreateFailure = () => {
  return {
    type: CORPORATE_LOCATION_CREATE_FAILURE
  }
};


export const locationsUpdateRequested = () => {
  return {
    type: CORPORATE_LOCATION_UPDATE_REQUESTED
  }
};

export const locationsUpdateSuccess = (location) => {
  return {
    type: CORPORATE_LOCATION_UPDATE_SUCCESS,
    location: location
  }
};

export const locationsUpdateFailure = () => {
  return {
    type: CORPORATE_LOCATION_UPDATE_FAILURE
  }
};


export const locationsDeleteRequested = (addressId) => {
  return {
    type: CORPORATE_LOCATION_DELETE_REQUESTED,
    addressId: addressId
  }
};

export const locationsDeleteSuccess = () => {
  return {
    type: CORPORATE_LOCATION_DELETE_SUCCESS
  }
};

export const locationsDeleteFailure = () => {
  return {
    type: CORPORATE_LOCATION_DELETE_FAILURE
  }
};


// Loads locations from BigCommerce AND loads additional addresses from SPO
export const locationsIndex = (signedPayload) => {
  return (dispatch) => {
    dispatch(locationsIndexRequested());

    let endPoint = Config.baseUrl + Config.locations;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(locationsIndexSuccess(response.data));
      })
      .catch((error) => {
        dispatch(locationsIndexFailure());
      });
  }
}


export const locationCreate = (signedPayload, location) => {
  return (dispatch) => {
    dispatch(locationsCreateRequested());

    let endPoint = Config.baseUrl + Config.location;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.post(endPoint, { location: location }, { headers: headers })
      .then((response) => {
        dispatch(locationsCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(locationsCreateFailure());
      });

  }
}

export const locationUpdate = (signedPayload, location) => {
  return (dispatch) => {

    dispatch(locationsUpdateRequested());

    let endPoint = Config.baseUrl + Config.location;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.put(endPoint, { location: location }, { headers: headers })
      .then((response) => {
        dispatch(locationsUpdateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(locationsUpdateFailure());
      });

  }
}

export const locationDelete = (signedPayload, locationId) => {
  return (dispatch) => {

    dispatch(locationsDeleteRequested(locationId));

    let endPoint = Config.baseUrl + Config.location + locationId;
    let headers = Object.assign(Config.headers);
    headers.payload = signedPayload;

    return Axios.delete(endPoint, { headers: headers })
      .then((response) => {
        dispatch(locationsDeleteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(locationsDeleteFailure());
      });


  }
}
